<template>
  <router-view></router-view>
</template>

<script setup>
</script>

<style>

@import "~bootstrap/dist/css/bootstrap.min.css";
@import "~@awesome.me/kit-c2451eec8d/icons/css/all.min.css";

#app {

  a {
    text-decoration: none;
    color: #63B32F;
  }

  a.active > span {
    text-decoration: underline;
  }


}
</style>
